import { useEffect } from 'react';
import { IKMeansParameters } from './k-means-interfaces';
import { useKMeansStore } from './dal/kmeans-store';
import KMeansParameters from './ui/parameters';
import Iteration from './ui/iteration';

const initialParameters: IKMeansParameters = {
    centroids: [
        [1,0,0],
        [0,1,1]
    ],
    points: [
        [1,2,3],
        [0,1,2],
        [3,0,5],
        [4,1,3],
        [5,0,1]
    ],
    centroidsPrefix: 'C',
    pointsPrefix: 'P',
};

const KMeansHome = () => {

    const params = useKMeansStore(store => store.params);
    const setParams = useKMeansStore(store => store.setParams);

    useEffect(() => {
        setParams(initialParameters);
    }, [setParams]);

    return(
        <div className="w-full py-2 overflow-auto">

            <div className="w-full mb-4">
                <h1 className="text-2xl px-2 mb-4">K-Means (ניתוח אשכולות)</h1>

                <div className="flex gap-4 ml-2">
                    <KMeansParameters />

                    {/* Result */}
                    {
                        params &&
                        <div className="border flex-1 p-4">
                            <Iteration
                                params={ params }
                                index={ 1 }
                            />
                        </div>
                    }
                </div>
            </div>

        </div>
    )
};

export default KMeansHome;
